import type { Commit } from 'vuex';

interface State {
  itemDetachingId: number | string | null;
  isActiveItemDetaching: boolean;
}

const state = (): State => ({
  itemDetachingId: null,
  isActiveItemDetaching: false,
});

const actions = {
  setItemDetaching(
    { commit }: { commit: Commit },
    { id, isActive }: { id?: number | string | null; isActive?: boolean }
  ) {
    commit('SET_ITEM_DETACHING', { id, isActive });
  },
  clearItemDetaching({ commit }: { commit: Commit }) {
    commit('SET_ITEM_DETACHING', { id: null, isActive: false });
  },
};

const mutations = {
  SET_ITEM_DETACHING(state: State, { id, isActive }: { id?: number | string | null; isActive?: boolean }) {
    if (id !== undefined) {
      state.itemDetachingId = id;
    }
    if (isActive !== undefined) {
      state.isActiveItemDetaching = isActive;
    }
  },
};

export default {
  namespaced: true,
  actions,
  state,
  mutations,
};
